var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagePeopleAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 7.78556C22.0002 10.4286 19.5434 12.5711 16.5128 12.5711C15.7391 12.5711 15.0028 12.4315 14.3352 12.1795C13.8039 12.9798 12.9408 13.5744 11.1565 13.9968C11.0096 14.0316 10.9387 13.774 11.0666 13.6765C11.9759 12.9839 12.4504 12.2977 12.6157 11.1546C11.6326 10.2898 11.0254 9.09952 11.0254 7.78556C11.0254 5.14257 13.4822 3 16.5128 3C19.5434 3 22.0002 5.14257 22.0002 7.78556Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 15.4C7.74264 15.4 8.75 14.415 8.75 13.2C8.75 11.985 7.74264 11 6.5 11C5.25736 11 4.25 11.985 4.25 13.2C4.25 14.415 5.25736 15.4 6.5 15.4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 16.5C2.50368 16.5 2 16.9925 2 17.6C2 20.0301 4.01472 22 6.5 22C8.98528 22 11 20.0301 11 17.6C11 16.9925 10.4963 16.5 9.875 16.5H3.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagePeopleAlt);
export default __webpack_public_path__ + "static/media/message-people-alt.6a7ff002b67c9379ee6c284e43602e47.svg";
export { ForwardRef as ReactComponent };